export default "__VITE_ASSET__QXYMgGc9__"